import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Clipboard: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[28px] h-[28px] stroke-[2px]', className)}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6667 4.66602H21C21.6188 4.66602 22.2123 4.91185 22.6499 5.34943C23.0875 5.78702 23.3333 6.38051 23.3333 6.99935V23.3327C23.3333 23.9515 23.0875 24.545 22.6499 24.9826C22.2123 25.4202 21.6188 25.666 21 25.666H6.99999C6.38115 25.666 5.78766 25.4202 5.35007 24.9826C4.91249 24.545 4.66666 23.9515 4.66666 23.3327V6.99935C4.66666 6.38051 4.91249 5.78702 5.35007 5.34943C5.78766 4.91185 6.38115 4.66602 6.99999 4.66602H9.33332"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 2.33398H10.5C9.85568 2.33398 9.33334 2.85632 9.33334 3.50065V5.83398C9.33334 6.47832 9.85568 7.00065 10.5 7.00065H17.5C18.1443 7.00065 18.6667 6.47832 18.6667 5.83398V3.50065C18.6667 2.85632 18.1443 2.33398 17.5 2.33398Z"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Clipboard;
